SubmittingButtonDirective = ($filter) ->
  restrict: 'A'
  link: (scope, elem, attrs) ->
    submittingMessage = $filter('translate')('PROCESSING')
    scope.$watch attrs.gnpSubmittingButton, (isSubmitting) ->
      if isSubmitting
        elem.data('defaultText', elem.text())
        elem.text(submittingMessage).prop('disabled', true)
      else
        elem.text(elem.data('defaultText')).prop('disabled', false)

SubmittingButtonDirective.$inject = ['$filter']

module.exports = SubmittingButtonDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/submitting-button-directive.coffee